<div class="popup">
    <p *ngIf="success == true" class="success-popup">Saved!</p>
    <p *ngIf="success == false" class="reject-popup">Rejected!</p>
</div>

<div class="container" *ngIf="isSkeltonLoad">
    <div class="row">
        <div class="col main oldpassword" *ngFor="let item of skeltonArray">
            <form class="form-skelton">
                <div class="headingSkelton"></div>
                <div class="">
                    <div class="imageSkelton">
                        <div class="imgtextSkelton"></div>
                    </div>
                </div>
                <div class="textSkelton"></div>
                <div class="textBoxSkelton"></div>
                <div class="textSkelton"></div>
                <div class="textBoxSkelton"></div>
                <div class="textSkelton"></div>
                <div class="textBoxSkelton"></div>
                <div class="buttonSkelton"></div>
            </form>
        </div>
    </div>
</div>

<div class="container" *ngIf="!isSkeltonLoad">
    <div class="row">
        <div class="col main">
            <form [formGroup]="UpdateDetails" (ngSubmit)="submit()" [ngStyle]="{ height: windowWidth}">
                <p class="heading">Edit Profile</p>
                <div class="whole-wrapper">
                    <div class="upload">
                        <input type="file" class="upload-file" (change)="selectedFile($event)" accept="image/*">
                        <img *ngIf="profilePicturedisplaytemp === ''" src="{{profilePicturedisplay}}"
                            class="upload-img">
                        <img *ngIf="profilePicturedisplaytemp !== ''" src="{{profilePicturedisplaytemp}}"
                            class="upload-img">
                        <!--  :{{constants.SKELTON_PROFILE_IMG}}  -->
                        <span class="upload-txt">Change Profile Photo</span>
                    </div>
                    <div class="firstname">
                        <label class="label">First Name</label>
                        <input class="input-text" id="input-password" type="text" placeholder="First Name"
                            formControlName="firstName">
                        <span class="input-text-required"
                            *ngIf="UpdateDetails.get('firstName').errors?.required && (UpdateDetails.get('firstName').dirty || UpdateDetails.get('firstName').touched)">
                            Field Cannot be empty<br></span>
                        <span class="input-text-required" *ngIf="UpdateDetails.controls.firstName.errors?.required">
                            First Name is required </span>
                    </div>
                    <div class="lastname">
                        <label class="label">Last Name</label>
                        <input class="input-text" id="input-password" type="text" placeholder="Last Name"
                            formControlName="lastName">
                        <span class="input-text-required"
                            *ngIf="UpdateDetails.get('lastName').errors?.required && (UpdateDetails.get('lastName').dirty || UpdateDetails.get('lastName').touched)">
                            Field Cannot be empty<br></span>
                        <span class="input-text-required" *ngIf="UpdateDetails.controls.lastName.errors?.required">
                            Last Name is required </span>
                    </div>
                    <div class="email">
                        <label class="label">Email</label>
                        <input class="grey-text" id="input-email" type="Email" placeholder="Email" value="{{email}}"
                            disabled>
                    </div>
                </div>
                <div class="save-div">
                    <button class="save" type="submit" [disabled]="UpdateDetails.invalid">
                        <span *ngIf="isloading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        Save
                    </button>
                </div>

            </form>
        </div>
    </div>
</div>